// 原始班级api
import { baseRequest, fileRequest } from './base'

import store from '../vuex'

/**
 * @desc 查询原始班级列表
 */
function getOriginalClassList(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaOriginalClass/'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 根据原始班级ID获取原始班级信息
 */
function getOriginalClassById(id) {
  return baseRequest(`/api/pcWeb/teaOriginalClass/${id}`, 'get');
}

/**
 * @desc 新增原始班级
 */
function addOriginalClass(params) {
  return baseRequest(`/api/pcWeb/teaOriginalClass/create`, 'post', params);
}

/**
 * @desc 删除原始班级
 */
function deleteOriginalClass(id) {
  return baseRequest(`/api/pcWeb/teaOriginalClass/delete/${id}`, 'get');
}

/**
 * @desc 修改原始班级
 */
function updateOriginalClass(id, params) {
  return baseRequest(`/api/pcWeb/teaOriginalClass/update/${id}`, 'post', params);
}

/**
 * @desc 根据年级查询班级
 */
function getClass(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaOriginalClass/getClass'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 导入原始班级
 */
function importSourceClass(params) {
  return fileRequest(`/api/pcWeb/teaOriginalClass/import`, params);
}

/**
 * @desc 下拉搜索原始班级
 */
function selectSearch(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaOriginalClass/selectSearch'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 校验导入文件表头
 */
function checkHeader(params) {
  return fileRequest(`/api/pcWeb/teaOriginalClass/checkHeader`, params);
}

/**
 * @desc 校验导入文件信息
 */
function checkFileInfo(params) {
  return fileRequest(`/api/pcWeb/teaOriginalClass/checkFileInfo`, params);
}


/**
 * @desc 批量删除学生
 */
function batchDelete(params) {
  return baseRequest(`/api/pcWeb/teaOriginalClass/batchDelete`, 'post', params);
}


/**
 * @desc 查询年级类型列表
 */
function getGrandListAndType(id,params) {
  return baseRequest(`api/pcWeb/teaGrade/getGrandListAndType/${id}`, 'get', params);
}





/**
 * @desc 学校原始班级列表
 */
 function teaOriginalClass(params) {
  //如果选择了学校，加入学校字段
  if (store.getters.schoolId) {
    params = params ? params : {};
    params.schoolId = store.getters.schoolId;
  }

  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaOriginalClass/list'
  return baseRequest(tempUrl, 'get', params);
}



export default {
  getOriginalClassList: getOriginalClassList,
  getOriginalClassById: getOriginalClassById,
  addOriginalClass: addOriginalClass,
  deleteOriginalClass: deleteOriginalClass,
  updateOriginalClass: updateOriginalClass,
  getClass: getClass,
  importSourceClass: importSourceClass,
  selectSearch: selectSearch,
  checkHeader: checkHeader,
  checkFileInfo: checkFileInfo,
  batchDelete: batchDelete,
  teaOriginalClass,
  getGrandListAndType,
}